export default __webpack_public_path__ + "static/media/kaus-wireframes-bw.f9370350.jpg";